/******************************************************************************
 *
 * WorkPeopleCard
 *
 * Compact Enterprise People Strip
 *
 * Displays all users involved in the Work in a single horizontal strip.
 *
 ******************************************************************************/

import React from "react";

export default function WorkPeopleCard({

    executors = [],

    owners = [],

    approvers = [],

    watchers = []

}) {

    function formatMembers(members = []) {

        if (!members.length) {

            return "None";

        }

        const names = members.map(

            member => member.member_name

        );

        if (names.length <= 3) {

            return names.join(", ");

        }

        return `${

            names.slice(0, 3).join(", ")

        } +${

            names.length - 3

        }`;

    }

    const totalMembers =

        executors.length +

        owners.length +

        approvers.length +

        watchers.length;

    return (

        <div
            className="py-2 mb-4"
            style={{
                borderTop: "2px solid #dee2e6",
                borderBottom: "2px solid #dee2e6",
                background: "transparent"
            }}
        >

            <div className="d-flex justify-content-between align-items-center mb-2">

                <div className="fw-semibold">

                    <i className="bi bi-people-fill text-primary me-2"></i>

                    People

                </div>

                <small className="text-muted">

                    Total Members : {totalMembers}

                </small>

            </div>

            <div
                className="small d-flex flex-wrap align-items-center"
                style={{
                    gap: "12px",
                    lineHeight: "1.8"
                }}
            >

                <span>

                    🔵 <strong>Executors :</strong>{" "}

                    {formatMembers(executors)}

                </span>

                <span className="text-muted">|</span>

                <span>

                    🟢 <strong>Owners :</strong>{" "}

                    {formatMembers(owners)}

                </span>

                <span className="text-muted">|</span>

                <span>

                    🟠 <strong>Approvers :</strong>{" "}

                    {formatMembers(approvers)}

                </span>

                <span className="text-muted">|</span>

                <span>

                    👁 <strong>Watchers :</strong>{" "}

                    {formatMembers(watchers)}

                </span>

            </div>

        </div>

    );

}